/* eslint-disable */
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import Flickity from "flickity";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

const HTML = document.querySelector("html");

gsap.registerPlugin(ScrollTrigger);

class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    // Toggle menu
    const toggles = document.querySelectorAll(".toggle-menu");
    if (toggles) {
      toggles.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          e.preventDefault();
          HTML.classList.toggle("open-menu");
        });
      });
    }

    this.blurScroll();
    this.slider();
    this.marquee();
    this.gifEffect();
    this.videoPlayer();
    this.inViewport();
  }

  videoPlayer() {
    const players = document.querySelectorAll(".player-js");

    if (players) {
      players.forEach((player) => {
        const video = player.querySelector("video:not(.preview)");

        if (video) {
          /** BUILD CONTROLS */
          const controls = document.createElement("div");
          controls.classList.add("controls");
          player.append(controls);

          const playPause = document.createElement("a");
          playPause.classList.add("play-pause");
          controls.append(playPause);

          const progress = document.createElement("div");
          progress.classList.add("progress");
          controls.append(progress);
          const bar = document.createElement("div");
          bar.classList.add("bar");
          progress.append(bar);

          const sound = document.createElement("a");
          sound.classList.add("sound");
          controls.append(sound);

          const fullscreen = document.createElement("a");
          fullscreen.classList.add("fullscreen");
          controls.append(fullscreen);

          const btnPlay = player.querySelector("[data-play]");
          if (btnPlay) {
            btnPlay.addEventListener("click", (e) => {
              e.preventDefault();
              video.play();
            });
          }
          const trigger = player.querySelector("[data-trigger-player]");
          if (trigger) {
            trigger.addEventListener("click", (e) => {
              e.preventDefault();
              video.play();
            });
          }

          /** EVENTS LISTENER */
          // CLICK
          playPause.addEventListener("click", (e) => {
            e.preventDefault();
            if (video.paused) video.play();
            else video.pause();
          });

          // PROGRESS CLICK
          progress.addEventListener("click", (e) => {
            const bounding = progress.getBoundingClientRect();
            const percent = (e.clientX - bounding.x) / bounding.width;

            video.currentTime = percent * video.duration;
          });

          // EVENTS
          player.addEventListener("play", () => {
            video.play();
          });
          player.addEventListener("pause", () => {
            video.pause();
          });

          // CLICK
          video.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (video.paused) video.play();
            else video.pause();
          });

          // FULLSCREEN
          fullscreen.addEventListener("click", (e) => {
            e.preventDefault();
            if (!video.fullscreenElement) {
              video.requestFullscreen();
            } else if (video.exitFullscreen) {
              video.exitFullscreen();
            }
          });

          // SOUND
          sound.addEventListener("click", (e) => {
            e.preventDefault();
            if (!video.muted) {
              video.muted = true;
              player.classList.add("soundoff");
            } else {
              video.muted = false;
              player.classList.remove("soundoff");
            }
          });

          video.addEventListener("mouseenter", () => {
            player.classList.add("is-mouseenter");
          });
          video.addEventListener("mouseleave", () => {
            player.classList.remove("is-mouseenter");
          });

          // IS PLAYING
          video.addEventListener("playing", () => {
            player.classList.add("is-playing");
          });
          // IS PAUSE
          video.addEventListener("pause", () => {
            player.classList.remove("is-playing");
          });

          // TIMEUPDATE
          video.addEventListener("timeupdate", () => {
            gsap.set(bar, {
              width: `${(video.currentTime / video.duration) * 100}%`,
            });
          });
        }
      });
    }
  }

  blurScroll() {
    const elts = document.querySelectorAll(".blur-scroll");

    if (elts) {
      elts.forEach((el) => {
        gsap.to(el.querySelector(".mask"), {
          height: "0%",
          scrollTrigger: {
            trigger: el,
            scrub: 1,
            start: "top +=80%",
          },
        });
      });
    }
  }

  marquee() {
    const elts = document.querySelectorAll(".marquee .line");
    if (elts) {
      elts.forEach((track) => {
        track.innerHTML += track.innerHTML;

        this.lazyload.update();

        let direction = 1; // 1 = vers la gauche, -1 = vers la droite
        const speed = 40; // pixels par seconde
        let x = 0; // position actuelle
        let wrapWidth; // largeur d’un bloc A
        let lastScrollY = window.scrollY;

        function computeWrapWidth() {
          // On divise par 2 car on a mis A + A
          wrapWidth = track.scrollWidth / 2;
        }

        // 2) Calcul initial + recalcul au resize
        window.addEventListener("load", computeWrapWidth);
        window.addEventListener("resize", computeWrapWidth);

        // 3) Détection du sens de scroll
        window.addEventListener(
          "scroll",
          () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY > lastScrollY) {
              // Scroll vers le bas → texte va vers la gauche
              direction = 1;
            } else if (currentScrollY < lastScrollY) {
              // Scroll vers le haut → texte va vers la droite
              direction = -1;
            }

            lastScrollY = currentScrollY;
          },
          { passive: true }
        );

        // 4) Animation avec GSAP.ticker (boucle infinie)
        let lastTime = performance.now();

        gsap.ticker.add(() => {
          const now = performance.now();
          const dt = (now - lastTime) / 1000; // secondes écoulées
          lastTime = now;

          if (!wrapWidth) return; // au cas où le layout n’est pas encore prêt

          // Mise à jour de la position en fonction du temps, de la vitesse et du sens
          x += direction * speed * dt;

          // 5) Normalisation dans l’intervalle [-wrapWidth, 0]
          //    pour boucler proprement dans les deux sens.
          if (x <= -wrapWidth) {
            x += wrapWidth;
          } else if (x >= 0) {
            x -= wrapWidth;
          }

          gsap.set(track, { x }); // applique transform: translateX(x)
        });
      });
    }
  }

  gifEffect() {
    const elts = document.querySelectorAll(".gif-hover");

    if (elts) {
      elts.forEach((figure) => {
        const images = gsap.utils.toArray(".inner", figure);

        gsap.set(images, { autoAlpha: 0 });
        gsap.set(images[0], { autoAlpha: 1 });

        const tl = gsap.timeline({
          paused: true,
          repeat: -1,
        });

        images.forEach((img, i) => {
          tl.to(images, {
            autoAlpha: 0,
            duration: 0,
          });

          tl.to(images[i], {
            autoAlpha: 1,
            duration: 0,
          });

          tl.to(
            {},
            {
              duration: 0.2,
            }
          );
        });


        let timer = 0;
        let current = 0;
        figure.addEventListener("mouseenter", () => {
          tl.play();
          // timer = setInterval(() => {
          //   const next = current >= images.length - 1 ? 0 : current + 1;
          //   gsap.set(images[current], { autoAlpha: 0 });
          //   gsap.set(images[next], { autoAlpha: 1 });
          //   current = next;
          // }, 200);
        });
        figure.addEventListener("mouseleave", () => {
          // clearInterval(timer);
          tl.pause();
          // gsap.set(images, { autoAlpha: 0 });
          // gsap.set(images[0], { autoAlpha: 1 });
        });
      });
    }
  }

  slider() {
    const elts = document.querySelectorAll(".slider");

    if (elts) {
      elts.forEach((el) => {
        const parent = el.closest('section');
        let sliderBG = parent ? parent.querySelectorAll(".slider-bg figure") : null;
        let current = -1;

        const flkty = new Flickity(el, {
          prevNextButtons: false,
          pageDots: false,
          wrapAround: true,
          contain: false,
          cellAlign: "center",
          cellSelector: ".item",
          on : {
            select: function(index) {
              const currentIndex = this.selectedIndex;

              const forward = (currentIndex - current + this.slides.length) % this.slides.length;
              const backward = (current - currentIndex + this.slides.length) % this.slides.length;

              const direction = forward <= backward ? -1 : 1;

              if( sliderBG ) {
                let delay = 0;
                if( current >= 0 ) {
                  gsap.to(sliderBG[current], { 
                    opacity: 0 ,
                    x: `${direction * -30}%`,
                    duration: 0.3,
                    ease: "circ.inOut",
                  });

                  delay: 0.2;
                }

                gsap.fromTo(sliderBG[index], { 
                  opacity: 0 ,
                  x: `${direction * 30}%`
                }, {
                  opacity: 1,
                  x: "0%",
                  duration: 0.3,
                  ease: "power2.inOut",
                  delay
                });
              }
              current = index;
            }
          }
        });

        const next = el.querySelector(".next");
        if (next) {
          next.addEventListener("click", (e) => {
            e.preventDefault();
            flkty.next();
          });
        }
        const prev = el.querySelector(".prev");
        if (prev) {
          prev.addEventListener("click", (e) => {
            e.preventDefault();
            flkty.previous();
          });
        }
      });
    }
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.1,
    });
    inView(".js-reveal:not(.is-visible)")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
